import { useState } from 'react';

import { Button } from '@material-ui/core';
import { useModal } from 'react-modal-hook';

import ModalIniciarContato from 'components/ModalIniciarContato';
import ModalListaContatos from 'components/ModalListaContatos';
import { ContatoInterface } from 'store/reducers/contatos';

export default function ButtonIniciarContato() {
  const [contatoSelected, setContatoSelected] = useState<ContatoInterface>();

  const handleSelect = (contato: ContatoInterface) => {
    setContatoSelected(contato);

    hideModalListaContatos(); // Fecha o modal de lista de contatos
    showModalIniciarContato(); // Abre o modal para iniciar contato com o contato selecionado
  };

  const [showModalListaContatos, hideModalListaContatos] = useModal(
    ({ in: open }) => (
      <ModalListaContatos
        open={open}
        onClose={hideModalListaContatos}
        selected={contatoSelected}
        onSelect={handleSelect}
      />
    ),
    [contatoSelected],
  );

  const [showModalIniciarContato, hideModalIniciarContato] = useModal(
    ({ in: open }) => (
      <ModalIniciarContato
        open={open}
        onClose={() => {
          hideModalIniciarContato();
          setContatoSelected(undefined);
        }}
        contato={contatoSelected}
        onChangeContatoSelected={() => showModalListaContatos()}
        onSuccess={() => setContatoSelected(undefined)}
      />
    ),
    [contatoSelected],
  );

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={showModalListaContatos}
    >
      Iniciar contato
    </Button>
  );
}
